import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { APIS } from 'src/app/apis';
import { MoovInstanceData } from '../challenge/challenges-data';
import { ConflictData, ConflictMoovData } from './conflicts-data';

@Injectable({
  providedIn: 'root'
})
export abstract class AbstractConflictsService {
  
  abstract getConflictsForUsers (teamMemberId: string, counterpartId: string): Observable<ConflictData[]> ;

  abstract getConflictMoovs (conflictId: string): Observable<ConflictMoovData[]> ;

  abstract getConflictsMoovsForUsers (teamMemberId: string, counterpartId: string): Observable<ConflictMoovData[]> ;

  abstract activateConflictMoov (moovId: string, firstCounterpartId: string, secondCounterpartId: string): Observable<MoovInstanceData> ;
}
